<mode-nav-menu-container target="_self"> </mode-nav-menu-container>

<header
  capra-header
  [navOpen]="(navOpen$ | async) ?? false"
  [showHamburger]="(navOpen$ | async) === false"
  (navToggleClick)="openNav()"
>
  <mode-workspace-avatar
    capra-header-avatar
    *ngIf="workspace"
    shape="square"
    [type]="workspace.avatar.type"
    [initials]="workspace.avatar.initials"
    [colorClass]="workspace.avatar.colorClass"
    [imageSrc]="workspace.avatar.href"
    [imageName]="workspace.name"
    [isCommunity]="workspace.user"
  ></mode-workspace-avatar>

  <ng-container capra-header-details>
    <mode-breadcrumbs
      *ngIf="breadcrumbs.length"
      class="breadcrumbs"
      [breadcrumbs]="breadcrumbs"
      data-test="breadcrumbs"
    >
      <ng-content mode-breadcrumbs-name-prefix select="[mode-header-name-prefix]"></ng-content>
    </mode-breadcrumbs>
  </ng-container>

  <ng-container capra-header-right>
    <ng-content></ng-content>

    <mode-header-search theme="dark" data-test="header-search"></mode-header-search>

    <mode-report-creation-menu
      class="report-creation-menu"
      [org]="(orgContext$ | async)?.username"
      theme="dark"
      data-test="report-creation-menu"
    ></mode-report-creation-menu>

    <mode-help-menu
      class="help-menu"
      [isGuest]="(isLoggedIn$ | async) === false"
      [isCommunity]="(orgContext$ | async)?.user ?? false"
      theme="dark"
      data-test="help-menu"
    ></mode-help-menu>
  </ng-container>
</header>
